import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import Clickable from '../../../components/Clickable';

import artBookAPro from '../assets/art-bookpro.png';
import artDocs from '../assets/art-docs.png';
import artHome from '../assets/art-home-team.png';
import artProReferral from '../assets/art-proreferrals.png';
import artSafety from '../assets/art-safety.png';

import containerStyle from './CommunicationCarousel.scss';
import qmStyles from '../../../theme/qmStyles';

const carousalData = [
  {
    title: 'Manage your home as a team!',
    subtitle:
      'Invite household members to join Quartermaster so you can manage your home together',
    image: artHome,
  },
  {
    title: 'Keep track of all your projects and documents',
    subtitle:
      'Home improvements can be hassle-free. All your home assets and documents in one place.',
    image: artDocs,
  },
  {
    title: 'Share Pro referrals with your neighbours',
    subtitle:
      'Share the hidden gems you know to support your favourite professionals.',
    image: artProReferral,
  },
  {
    title: 'Book your next Pro through verified referrals',
    subtitle:
      'Find the best Pros in your neighbourhood at your fingertips. We are always here to help.',
    image: artBookAPro,
  },
  {
    title: 'Safe and Verified Community',
    subtitle:
      'Quartermaster is a home organization and Pro referral app that only verified neighbours like you can join.',
    image: artSafety,
  },
];

class CommunicationCarousel extends Component {
  constructor(props) {
    super(props);

    this.slider = React.createRef();
    window.controller = this;
  }

  state = {
    currentIndex: 0,
  };

  slidePrev = () => {
    this.slider.current.slickPrev();
  };

  slideNext = () => {
    this.slider.current.slickNext();
  };

  handleEnd = () => {
    const { closeModal } = this.props;

    closeModal();
  };

  renderNextArrow = () => {
    const { currentIndex } = this.state;
    const isLastSlide = currentIndex === 4;

    return (
      <Clickable
        onClick={isLastSlide ? this.handleEnd : this.slideNext}
        className={`${containerStyle.nextArrow}`}
      >
        {isLastSlide && <p className={containerStyle.nextArrowText}>Done</p>}
        <div
          className={`qm-icon-slide-right ${containerStyle.nextArrowIcon}`}
        />
      </Clickable>
    );
  };

  renderPrevArrow = () => {
    const { currentIndex } = this.state;
    const isFirstSlide = currentIndex === 0;

    return (
      <Clickable
        onClick={this.slidePrev}
        className={containerStyle.prevArrow}
        style={{ cursor: isFirstSlide ? 'default' : '' }}
      >
        <div
          className={`qm-icon-slide-left ${containerStyle.prevArrowIcon}`}
          style={{ color: isFirstSlide ? qmStyles.greyLightest : '' }}
        />
      </Clickable>
    );
  };

  renderDots = dots => {
    return <div className={containerStyle.dot}>{dots}</div>;
  };

  render() {
    const { closeModal } = this.props;

    return (
      <div className={containerStyle.container}>
        <div className={containerStyle.sliderContainer}>
          <div className={containerStyle.header}>
            <Clickable
              className={`qm-icon-close ${containerStyle.closeButton}`}
              onClick={closeModal}
              style={{ zIndex: 2 }}
            />
          </div>
          <Slider
            ref={this.slider}
            dots
            arrows={false}
            slidesToScroll={1}
            slidesToShow={1}
            appendDots={this.renderDots}
            infinite={false}
            beforeChange={(prevIndex, nextIndex) => {
              this.setState({ currentIndex: nextIndex });
            }}
          >
            {carousalData.map(page => (
              <div key={page.image}>
                <div className={containerStyle.content}>
                  <div className={containerStyle.imageContainer}>
                    <img src={page.image} />
                  </div>
                  <h3 className={containerStyle.title}>{page.title}</h3>
                  <p className={containerStyle.subtitle}>{page.subtitle}</p>
                </div>
              </div>
            ))}
          </Slider>
          <div className={containerStyle.arrowContainer}>
            {this.renderPrevArrow()}
            {this.renderNextArrow()}
          </div>
        </div>
      </div>
    );
  }
}

CommunicationCarousel.propTypes = {
  closeModal: PropTypes.func.isRequired,
};

export default CommunicationCarousel;
